import { Box } from "@mui/material";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import CMSForm from "../paper-claim/CMSFom";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { useEffect, useState } from "react";
import { useGetSuperBillCMS1500ById } from "../../../../../queries/billings/use-get-claim-CMS1500-by-id";

interface ViewPaperClaimByInvoiceIdDrawerProps {
  disclosureHost: DisclosureHost;
}

const ViewPaperClaimByInvoiceIdDrawer = ({
  disclosureHost,
}: ViewPaperClaimByInvoiceIdDrawerProps) => {
  const { data: claimData, isLoading: isLoadingClaim } =
    useGetSuperBillCMS1500ById({
      superBillUuid: disclosureHost?.data ?? "",
    });
  const prefillData = claimData?.data;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Create a modified disclosure host with the prefill data
  // This ensures CMSForm receives the correct data (either fetched or passed directly)
  const disclosureHostWithData = {
    ...disclosureHost,
    data: prefillData,
  };

  // Only render CMSForm when we have prefill data (if UUID was provided, wait for data to load)
  const shouldRenderCMSForm = !!prefillData;

  return (
    <SideSheetDrawer
      title=""
      w="55vw"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
    >
      <LoadingOverlay
        isLoading={isLoading || isLoadingClaim || !shouldRenderCMSForm}
      />
      {shouldRenderCMSForm && (
        <Box>
          <CMSForm disclosureHost={disclosureHostWithData} />
        </Box>
      )}
    </SideSheetDrawer>
  );
};

export default ViewPaperClaimByInvoiceIdDrawer;
